
import { Options, Vue } from "vue-class-component";
import EmptyState from "@/app/ui/components/empty-list/index.vue";
import { ellipsisString, formatDateWithoutTime, formatTimeNumber } from "@/app/infrastructures/misc/Utils";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { translateStatusClient } from "@/app/ui/views/sales/clients/client-management/utils-client-management";
import FreezeUnfreezePopup from "@/app/ui/views/sales/clients/client-management/component/freeze-unfreeze-popup.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { FlagsPermissionClient } from "@/feature-flags/flags-permission-client";
import { formatDate } from "@/app/infrastructures/misc/Utils";

@Options({
  components: {
    EmptyState,
    FreezeUnfreezePopup
  },

  computed: {
    isDetailAble() {
      return FlagsPermissionClient.permission_client_management_detail_view.isEnabled();
    },
    isActionAble() {
      return FlagsPermissionClient.permission_client_management_detail_edit.isEnabled();
    }
  }
})
export default class ClientManagementV2 extends Vue {
  get isDetailAble() {
    return FlagsPermissionClient.permission_client_management_detail_view.isEnabled();
  }

  get isActionAble() {
    return FlagsPermissionClient.permission_client_management_detail_edit.isEnabled();
  }

  mounted() {
    ClientManagementController.initClientManagement();
  }
  onRequest() {
    ClientManagementController.fetchClientManagementList();
  }
  get firstRequest() {
    return ClientManagementController.firstRequest;
  }
  get clientManagement() {
    return ClientManagementController.clientManagementData.data;
  }

  // filter Search
  onSearch(value: string) {
    ClientManagementController.searchAction(value);
  }
  get searchValue() {
    return ClientManagementController.search;
  }
  clearSearch() {
    ClientManagementController.clear();
  }

  // rates
  statusSelect = false;
  statusName = "";
  get statusRates() {
    return [
      {
        name: this.$t("clientManagement.managementList.allPrices").toString(),
        value: ""
      },
      { name: this.$t("clientManagement.infoPriceClient.active").toString(), value: "active" },
      { name: this.$t("clientManagement.infoPriceClient.pending").toString(), value: "pending" },
      {
        name: this.$t("clientManagement.infoPriceClient.nearlyExpired").toString(),
        value: "nearly_expired"
      },
      { name: this.$t("clientManagement.infoPriceClient.expired").toString(), value: "expired" }
    ];
  }
  onOpenStatusSelect() {
    this.statusSelect = true;
  }
  onCloseStatusSelect() {
    this.statusSelect = false;
  }
  onSelectStatus(name: string, value: string) {
    ClientManagementController.selectStatusRatesAction({
      name: name,
      value: value
    });
    this.statusName = name;
    this.onCloseStatusSelect();
  }

  // renewal
  statusSelectRenewal = false;
  statusNameRenewal = "";
  get statusDataRenewal() {
    return [
      {
        name: this.$t("clientManagement.managementList.allClientStatuses").toString(),
        value: ""
      },
      { name: this.$t("clientManagement.managementList.frozen").toString(), value: "freeze" },
      { name: this.$t("clientManagement.infoPriceClient.active").toString(), value: "non-freeze" }
    ];
  }
  onOpenStatusSelectRenewal() {
    this.statusSelectRenewal = true;
  }
  onCloseStatusSelectRenewal() {
    this.statusSelectRenewal = false;
  }
  onSelectStatusRenewal(name: string, value: string) {
    ClientManagementController.selectStatusRenewalAction({
      name: name,
      value: value
    });
    this.statusNameRenewal = name;
    this.onCloseStatusSelectRenewal();
  }

  // type client
  typeSelect = false;
  typeName = "";
  onOpenTypeSelect() {
    this.typeSelect = true;
  }
  onCloseTypeSelect() {
    this.typeSelect = false;
  }
  onSelectType(name: string, value: string) {
    ClientManagementController.selectTypeAction({
      name: name,
      value: value
    });
    this.typeName = name;
    this.onCloseTypeSelect();
  }

  // advance filter
  isAdvancedFilterOpened = false;
  onChangeAdvancedFilter = () => null;
  onOpenedAdvancedFilter(event: any) {
    this.isAdvancedFilterOpened = event;
  }
  onResetAdvancedFilter() {
    ClientManagementController.resetAllFilterPopup()
    this.statusName = "";
    this.statusNameRenewal = "";
    this.typeName = "";
  }
  advancedFilterData: any = null;

  get isCollapseSidebar() {
    return AccountController.isCollapseSidebar;
  }

  get typeData() {
    return [
      {
        name: this.$t("clientManagement.managementList.allClientTypes").toString(),
        value: ""
      },
      {
        name: this.$t("clientManagement.managementList.parentClient").toString(),
        value: "parent"
      },
      {
        name: this.$t("clientManagement.managementList.branchClient").toString(),
        value: "branch"
      }
    ];
  }

  get countFilter() {
    return (
      (ClientManagementController.filterStatusRates ? 1 : 0) +
      (ClientManagementController.filterStatusRenewal ? 1 : 0) +
      (ClientManagementController.filterType ? 1 : 0)
    );
  }

  // handling
  get isLoading() {
    return ClientManagementController.isLoading;
  }
  get isError() {
    return ClientManagementController.isError;
  }
  get errorCause() {
    return ClientManagementController.isErrorCause;
  }
  onClickRow(item: any) {
    this.$router.push(
      `/client/client-management/${item.clientId}?params=${item.clientCode}`
    );
  }
  get pagination() {
    return ClientManagementController.clientManagementData.pagination;
  }

  statusRenewalChips(status: string) {
    switch (status) {
      case "approved":
        return "check-circle";
      case "requested":
        return "timer";
      case "rejected":
        return "x-circle";
      default:
        return "check-circle";
    }
  }

  iconRenewalChip(status: string) {
    return require(`@/app/ui/assets/svg/${this.statusRenewalChips(
      status
    )}.svg`);
  }

  get columns() {
    return [
      {
        name: this.$t("clientManagement.managementList.columns.clientId").toString(),
        styleHead: "w-24 text-left whitespace-no-wrap",
        styleBody: "text-red-lp-200 text-center",
        render: (item: any) => {
          return `<span class='text-left text-red-lp-200 flex justify-center'>${item.clientId}</span>`;
        }
      },
      {
        name: this.$t("clientManagement.managementList.columns.clientName").toString(),
        styleHead: "w-60 text-left whitespace-no-wrap",
        styleBody: "",
        render: (item: any) => {
          return `<span class="overflow-ellipsis text-black-lp-300 break-all">${item.clientCompanyName}</span>`;
        }
      },
      {
        name: this.$t("clientManagement.managementList.columns.alias").toString(),
        styleHead: "w-32 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<span class="overflow-ellipsis text-black-lp-300 truncate">${ellipsisString(item.clientAlias, 10) || "-"}</span>`;
        }
      },
      {
        name: this.$t("clientManagement.managementList.columns.clientCode").toString(),
        styleHead: "w-32 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<span class="overflow-ellipsis text-black-lp-300">${item.clientCode}</span>`;
        }
      },
      {
        name: this.$t("clientManagement.managementList.columns.clientType").toString(),
        styleHead: "w-36 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<span class="overflow-ellipsis text-black-lp-300">${item.clientType.toLowerCase() === "client induk" ? this.$t("clientManagement.managementList.parentClient") : this.$t("clientManagement.managementList.branchClient")}</span>`;
        }
      },
      {
        name: this.$t("clientManagement.managementList.columns.pricePeriodStart").toString(),
        styleHead: "w-64 text-left whitespace-no-wrap",
        sortBy: "rate_version_start_date",
        render: (item: any) => {
          return `<div class='flex text-black-lp-300'>
          ${formatDate(item.rateVersionStartDate, "DD MMMM YYYY", false, false)}<br />
          ${formatDate(item.rateVersionStartDate, "HH:mm")}
        </div>`;
        }
      },
      {
        name: this.$t("clientManagement.managementList.columns.pricePeriodEnd").toString(),
        styleHead: "w-64 text-left whitespace-no-wrap",
        sortBy: "rate_version_end_date",
        render: (item: any) => {
          return `<div class='flex text-black-lp-300'>
          ${formatDate(item.rateVersionEndDate, "DD MMMM YYYY", false, false)}<br />
          ${formatDate(item.rateVersionEndDate, "HH:mm")}
        </div>`;
        }
      },
      {
        name: this.$t("clientManagement.managementList.columns.contractStatus").toString(),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `
          <div class="flex">
          <div
            class="rounded-full px-2 py-0 text-center ${translateStatusClient(item.clientStatus).color
              } ${translateStatusClient(item.clientStatus).textColor}"
          ><span class="capitalize">${translateStatusClient(item.clientStatus).label
          }</span></div></div>`;
        }
      },
      {
        name: this.$t("clientManagement.managementList.columns.priceStatus").toString(),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `
          <div class="flex">
        <div
          class="rounded-full px-2 py-0 text-center ${translateStatusClient(item.rateVersionStatus.toLowerCase()).color
            } ${translateStatusClient(item.rateVersionStatus.toLowerCase()).textColor
            }"
        ><span class="capitalize">${translateStatusClient(item.rateVersionStatus.toLowerCase()).label
            }</span></div></div>`;
        }
      },
      {
        name: this.$t("clientManagement.managementList.columns.updateStatus").toString(),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: any) => {
          if (item.rateVersionStatusRenewal !== "") {
            return `
          <div class="flex">
        <div
          class="rounded-full px-2 py-0 text-center ${translateStatusClient(item.rateVersionStatusRenewal.toLowerCase())
                .color
              } ${translateStatusClient(item.rateVersionStatusRenewal.toLowerCase())
                .textColor
              }"
        ><span class="capitalize">${translateStatusClient(item.rateVersionStatusRenewal.toLowerCase())
                .label
              }</span></div></div>`;
          } else {
            return ``;
          }
        }
      },
      {
        name: this.$t("clientManagement.managementList.columns.action").toString(),
        key: "button_column",
        styleHead: "w-36 text-left",
        styleButton: (item: any) => {
          if (item.clientStatus === "freeze") {
            return {
              iconLeft: "circle-green",
              textColor: "green-lp-100",
              flat: true,
              compact: true,
              title: this.$t("clientManagement.managementList.unfreeze").toString(),
              customClass: ``,
              clickFunction: (e: any) => {
                MainAppController.setSnackbar(false);
                this.clientSelected = {
                  id: e.clientId,
                  name: e.clientCompanyName,
                  type: e.clientType,
                  status: true
                };
                this.freezeUnFreezeModal = true;
              }
            };
          }
          return {
            flat: true,
            compact: true,
            iconLeft: "circle-red",
            class: "w-full",
            textColor: "red-lp-100",
            customClass: ``,
            title: this.$t("clientManagement.managementList.freeze").toString(),
            clickFunction: (e: any) => {
              MainAppController.setSnackbar(false);
              this.clientSelected = {
                id: e.clientId,
                name: e.clientCompanyName,
                type: e.clientType,
                status: false
              };
              this.freezeUnFreezeModal = true;
            }
          };
        }
      }
    ];
  }

  // freeze un freeze
  freezeUnFreezeModal = false;
  clientSelected: any = "";

  get orderBy() {
    return ClientManagementController.orderBy;
  }

  get sortDirection() {
    return ClientManagementController.sortDirection;
  }
  onSort(sort: { sortBy: string; sortDirection: "ASC" | "DESC" | "" }) {
    ClientManagementController.sortAction({
      orderBy: sort.sortBy,
      sortDirection: sort.sortDirection,
    });
  }
}
